export const getGuideFamilyId = (guide) => String(guide?.parent_guide_id || guide?.ID || '');

export const isOriginalGuide = (guide) => (
  !guide?.parent_guide_id || String(guide.parent_guide_id) === String(guide.ID)
);

export const groupPublishedGuides = (guides = []) => {
  const groups = {};

  guides.forEach((guide) => {
    const groupId = getGuideFamilyId(guide);
    if (!groupId) return;

    if (!groups[groupId]) {
      groups[groupId] = {
        id: groupId,
        guides: [],
        primaryGuide: null,
      };
    }

    groups[groupId].guides.push(guide);

    if (!groups[groupId].primaryGuide && isOriginalGuide(guide)) {
      groups[groupId].primaryGuide = guide;
    }
  });

  Object.values(groups).forEach((group) => {
    if (!group.primaryGuide) {
      group.primaryGuide = group.guides[0] || null;
    }

    group.guides.sort((a, b) => {
      if (a === group.primaryGuide) return -1;
      if (b === group.primaryGuide) return 1;
      return String(a.Language || '').localeCompare(String(b.Language || ''));
    });
  });

  return Object.values(groups).sort((a, b) => {
    const aName = a.primaryGuide?.Translated_Name || a.primaryGuide?.Name || a.guides[0]?.Name || '';
    const bName = b.primaryGuide?.Translated_Name || b.primaryGuide?.Name || b.guides[0]?.Name || '';
    return aName.localeCompare(bName);
  });
};

const normalizeSearchValue = (value) => String(value || '').trim().toLowerCase();

export const matchesPublishedGuideSearch = (group, query) => {
  const normalizedQuery = normalizeSearchValue(query);
  if (!normalizedQuery) return true;

  const searchText = [
    group.id,
    group.primaryGuide?.ID,
    group.primaryGuide?.parent_guide_id,
    group.primaryGuide?.Name,
    group.primaryGuide?.Translated_Name,
    group.primaryGuide?.Locality,
    group.primaryGuide?.Country,
    ...group.guides.flatMap((guide) => [
      guide.ID,
      guide.parent_guide_id,
      guide.Name,
      guide.Translated_Name,
      guide.Language,
      guide.Locality,
      guide.Country,
      guide.Tags,
    ]),
  ]
    .map((part) => normalizeSearchValue(part))
    .filter(Boolean)
    .join(' ');

  return searchText.includes(normalizedQuery);
};

export const buildRelatedGuideFromPublishedGroup = (group) => {
  const guide = group?.primaryGuide || group?.guides?.[0];
  if (!guide) return null;

  return {
    guideId: String(group.id || guide.parent_guide_id || guide.ID || '').trim(),
    name: String(guide.Translated_Name || guide.Name || '').trim(),
    photoUrl: String(guide.Photo || '').trim(),
    website: String(guide.Website || '').trim(),
  };
};
